/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import * as Fleets from '../../api/Fleets'

export const CLEAR_STATE = 'CLEAR_STATE'
export const REQUEST_FLEETS_HIERARCHY = 'REQUEST_FLEETS_HIERARCHY'
export const RECEIVE_FLEETS_HIERARCHY = 'RECEIVE_FLEETS_HIERARCHY'
export const SUBMIT_FLEET = 'SUBMIT_FLEET'
export const REQUEST_FLEET = 'REQUEST_FLEET'
export const RECEIVE_FLEET = 'RECEIVE_FLEET'
export const GENERAL_RECEIVE = 'GENERAL_RECEIVE'
export const SET_FLEET_ATTRIBUTE = 'SET_FLEET_ATTRIBUTE'

export const fetchFleetsHierarchy = (includeAssets, fleetId) => dispatch => {
    dispatch(requestFleetsHierarchy());
    return Fleets.fetchHierarchy(includeAssets, true, fleetId).then(
        function (response) {
            dispatch(receiveFleetsHierarchy(response));
        }
    );
}

export const fetchFleet = (fleetId) => dispatch => {
    dispatch(requestFleetType());
    return Fleets.fetchSingleFleet(fleetId).then((response) => {
            dispatch(receiveFleetType(response))
        }
    );
}

export const createFleet = (fleet) => dispatch => {
    dispatch(submitFleetType(fleet));
    return Fleets.createFleet(fleet).then(
        function (response) {
            dispatch(receiveFleetType(response))
            return(response);
        }
    ).catch((err) => {
        dispatch(generalReceiveType())
        throw err;
    })
}

export const updateFleet = (fleet) => dispatch => {
    dispatch(submitFleetType(fleet))
    return Fleets.updateFleet(fleet).then(
        function (response) {
            dispatch(receiveFleetType(response))
            return(response);
        }
    ).catch((err) => {
        dispatch(generalReceiveType())
        throw err;
    })
}

export const clearState = () => dispatch => {
    dispatch(clearStateType())
}

export const deleteFleet = (fleet) => dispatch => {
    dispatch(submitFleetType(fleet))
    return Fleets.deleteFleet(fleet.id).then(
        function (response) {
            dispatch(generalReceiveType())
            return(response);
        }
    ).catch((err) => {
        dispatch(generalReceiveType())
        throw err;
    })
}

export const setFleetAttr = (key, value) => dispatch => {
    dispatch(setFleetAttrType(key, value))
}

const setFleetAttrType = (key, value) => {
    return {
        type: SET_FLEET_ATTRIBUTE,
        key: key,
        value: value,
    }
}

const clearStateType = () => {
    return {
        type: CLEAR_STATE,
    }
}

const requestFleetType = () => {
    return {
        type: REQUEST_FLEET,
    }
}

const receiveFleetType = (fleet) => {
    return {
        type: RECEIVE_FLEET,
        fleet: fleet,
    }
}

const receiveFleetsHierarchy = (fleets) => {
    return {
        type: RECEIVE_FLEETS_HIERARCHY,
        fleets: fleets,
    }
}

const requestFleetsHierarchy = () => {
    return {
        type: REQUEST_FLEETS_HIERARCHY,
    }
}

const submitFleetType = (fleet) => {
    return {
        type: SUBMIT_FLEET,
        fleet: fleet,
    }
}

const generalReceiveType = () => {
    return {
        type: GENERAL_RECEIVE,
    }
}